import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gap: 6,
    gridTemplateColumns: '1fr',
    alignItems: 'center',
    marginBottom: 24,
    backgroundColor: theme.palette.grey[200],
    padding: 10,
    borderRadius: 4
  },
  eachSeperatedRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
    marginTop: 10
  },
  counter: {
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    marginBottom: 5
  },
  RestrictionsContainer: {
    display: 'flex',
    '&>div': {
      marginRight: 12
    }
  },
  counterSkeleton: {
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))

export default useStyles
